import script from "./TestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TestCard.vue?vue&type=script&setup=true&lang=js"

import "./TestCard.vue?vue&type=style&index=0&id=4fe9bee8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe9bee8"]])

export default __exports__